module.exports = __webpack_public_path__ + "static/media/liblearner.f21a8d9a.jpeg";